import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('applicationDetailsPage');

    return {
        ACRES: t('acres'),
        ACTIVITY: t('activity'),
        ADJUSTED_BOUNDARY_NAME_TEMPLATE: t('adjustedBoundaryNameTemplate'),
        ADVANCED_SPRAY_SETTINGS_TITLE: t('advancedSpraySettingsTitle'),
        ADVANCED_TITLE: t('advancedTitle'),
        BACK: t('back'),
        BOUNDARY_EDIT_ADD_OBSTACLE: t('boundaryEditAddObstacle'),
        BOUNDARY_EDIT_DELETE_OBSTACLE: t('boundaryEditDeleteObstacle'),
        BOUNDARY_EDIT_DISCARD: t('boundaryEditDiscard'),
        BOUNDARY_EDIT_DONE: t('boundaryEditDone'),
        BOUNDARY_EDIT_MOVE_VERTICES: t('boundaryEditMoveVertices'),
        BOUNDARY_EDIT_TOOLBAR_LABEL: t('boundaryEditToolbarLabel'),
        BOUNDARY_MODIFIED_BADGE: t('boundaryModifiedBadge'),
        CONNECTING: t('connecting'),
        CORNER_FILL_HINT: t('cornerFillHint'),
        COVERAGE_AREA: t('coverageArea'),
        COVERAGE_OPTIONS_TITLE: t('coverageOptionsTitle'),
        CREATE_FLIGHT_PLAN: t('createFlightPlan'),
        DISCARD: t('discard'),
        EDIT_APPLICATION: t('editApplication'),
        EDIT_BOUNDARY_ENTRY: t('editBoundaryEntry'),
        EDIT_FLIGHT_PLAN: t('editFlightPlan'),
        EXPORT_TO_JOHN_DEERE: t('exportToJohnDeere'),
        FLIGHT_TIME: t('flightTime'),
        GALLONS: t('gallons'),
        HOME_POINT_CANCEL_PICK_BUTTON: t('homePointCancelPickButton'),
        HOME_POINT_LABEL: t('homePointLabel'),
        HOME_POINT_MARKER_ARIA_LABEL: t('homePointMarkerAriaLabel'),
        HOME_POINT_PICK_BUTTON: t('homePointPickButton'),
        HOME_POINT_PICK_HINT: t('homePointPickHint'),
        LAST_REPLAN_TEMPLATE: t('lastReplanTemplate'),
        LINKED_ENTITIES: t('linkedEntities'),
        LOAD_ERROR: t('loadError'),
        MAP_COMING_SOON: t('mapComingSoon'),
        PAGE_TITLE: t('pageTitle'),
        PASS_OVERLAP: t('passOverlap'),
        PASSES: t('passes'),
        PATH_ANGLE_HINT: t('pathAngleHint'),
        PLACEHOLDER_VALUE: t('placeholderValue'),
        PRIMARY_PARAMS_EYEBROW_SUBTITLE: t('primaryParamsEyebrowSubtitle'),
        PRIMARY_PARAMS_EYEBROW_TITLE: t('primaryParamsEyebrowTitle'),
        PRODUCTIVE: t('productive'),
        REPLANNING_LABEL: t('replanningLabel'),
        SAVE: t('save'),
        SAVE_ERROR: t('saveError'),
        SEND_TO_DRONE: t('sendToDrone'),
        SEND_TO_DRONE_FAILED: ({ error }: { error: string }) => t('sendToDroneFailed', { error }),
        SEND_TO_DRONE_NO_SESSION: t('sendToDroneNoSession'),
        SEND_TO_DRONE_RESULT: ({
            flightSeconds,
            tankUsed,
            waypointCount
        }: {
            flightSeconds: string;
            tankUsed: string;
            waypointCount: number;
        }) => t('sendToDroneResult', { flightSeconds, tankUsed, waypointCount }),
        SEND_TO_DRONE_SENDING: t('sendToDroneSending'),
        SPRAY_SETTINGS_TITLE: t('spraySettingsTitle'),
        TOTAL_DISTANCE: t('totalDistance'),
        TURNS: t('turns')
    };
};

export default useTranslation;
